import UsersTable from "./UsersTable";

export default function Supervisors() {
  return <UsersTable type="supervisor" />;
}
